<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm v-if="!loading">
                <h1>Register</h1>
                <p class="text-muted">Create your account</p>
                <!-- <CInput
                  v-model="username"
                  v-on:input="handleUsername"
                  placeholder="Username"
                  autocomplete="username"
                  required
                  :is-valid="isValidUsername"
                  :invalid-feedback="hint"
                >
                  <template #prepend-content><CIcon name="cib-superuser"/></template>
                </CInput> -->
                <CInput
                  v-model="username"
                  placeholder="Username"
                  autocomplete="username"
                  required
                  :is-valid="isValidUsername"
                  :invalid-feedback="hint"
                >
                  <template #prepend-content><CIcon name="cib-superuser"/></template>
                </CInput>
                <CInput
                  :placeholder="user.email"
                  autocomplete="email"
                  prepend="@"
                  disabled
                />
                <CInput
                  :placeholder="user.firstname"
                  disabled
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  :placeholder="user.lastname"
                  disabled
                >
                  <template #prepend-content><CIcon name="cil-people"/></template>
                </CInput>
                <CButton v-on:click="onRegisterClicked()" color="success" block :disabled="!isValidUsername">Create Account</CButton>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { axiosInstance } from '@/api'

export default {
  name: 'Register',
  data () {
    return {
      loading: true,
      username: '',
      hint: 'Please enter username.',
      clusterMembersObject: {}
    }
  },
  computed: {
    // isAuthenticated() {
    //   return this.$store.state.isAuthenticated
    // },
    user () {
      return this.$store.state.user
    },
    isValidUsername() {
      let hint = 'The value can contain only lowercase letters, numbers, dots(.) and hyphens(-) and must begin and end with a lowercase letter or number.'
      let re = /^[a-z0-9]([a-z0-9\-\.]*[a-z0-9])?$/;
      if (re.test(this.username)) {
        if(this.username.length > 32) {
          this.hint = 'The maximum length is 32 characters.'
          return false
        }
        
        if (this.clusterMembersObject[this.username] !== undefined) {
          this.hint = 'The username already exists.'
          return false
        }
        return true
      } else {
        this.hint = hint
        return false
      }
    },
  },
  mounted() {
    // console.log('register mounted()')
    this.syncUser()
  },
  methods: {
    // handleUsername(e) {
    //   console.log('username', this.username)
    // },
    syncUser() {
      axiosInstance({
        method: 'post',
        url: '/cluster/user',
      })
      .then(response => {
        // console.log(`syncUser() resp_code: ${response.status}`)
        if(response.status === 200) {
          this.$router.push({ name: 'Home' })
        } else if(response.status === 204) {
          this.username = this.$store.state.user.username
          this.loading = false
          this.getClusterMembers()
        } else {
          console.log('Error ['+response.status+']: '+response.data.message+', please contact admin')
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          if(error.response.status === 400) {
            this.$router.push({ name: 'Home' })
          } else {
            console.log('Error ['+error.response.status+']: '+error.response.data.message)
          }
        }
      })
    },
    getClusterMembers () {
      axiosInstance({
        method: 'get',
        url: '/cluster/user/kubesphere'
      })
      .then(response => {
        if(response.status === 200) {
          let clusterMembersObject = {}
          response.data.users.forEach(function(element) {
            let member = {}
            if (element["spec"] !== undefined) {
              if (element["spec"]["email"] !== undefined)
                member["email"] = element["spec"]["email"]
            }
            clusterMembersObject[element.metadata.name] = member;
          })
          this.clusterMembersObject = clusterMembersObject
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log('Error ['+error.response.status+']: '+error.response.data.message)
        }
      })
    },
    onRegisterClicked() {
      axiosInstance({
        method: 'put',
        url: '/cluster/user',
        data: {
          username: this.username
        }
      })
      .then(response => {
        if(response.status === 200) {
          this.$router.push({ name: 'Home' })
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log('Error ['+error.response.status+']: '+error.response.data.message)
        }
      })
    },
  }
}
</script>
